import React, { useState } from "react";
import {
  defaultStaticRanges,
  DefinedRange,
} from "react-date-range";

import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { useDispatch } from "react-redux";
import { setDateRange } from "../../../../redux/SearchSlice";
import { useSelector } from "react-redux";
import { useSearchParamActions } from "../../../../hooks/useSearchParamActions";
import { useResponsive } from "../../../../hooks/useResponsive";
import CustomDateRangePicker from "./CustomDateRangePicker";
import { CustomButton } from "../../../../components/Button/Button";
import {
  getWorklogDateRangeSearchParams,
  parseWorklogDateRangeParams,
} from "../../utils/myTaskUtils";

function DateRange({ onClose, customStaticRanges }) {
  const { searchParams, updateSearchParams, removeSearchParams } =
    useSearchParamActions();
  const dispatch = useDispatch();
  const dateRange = useSelector((state) => state.search.dateRange);
  const date = parseWorklogDateRangeParams({
    from: searchParams.get("from"),
    days: searchParams.get("days"),
    to: searchParams.get("to"),
    date: searchParams.get("date"),
  });
  const isMobile = useResponsive("down", "md");

  const [showCustomComponent, setShowCustomComponent] = useState(false);
  const [state, setState] = useState([
    dateRange
      ? dateRange
      : {
          startDate: date ? new Date(date.startDate) : new Date(),
          endDate: date ? new Date(date.endDate) : new Date(),
          key: "selection",
        },
  ]);

  const setData = () => {
    dispatch(setDateRange(state[0]));
    const { from, days } = getWorklogDateRangeSearchParams(state[0]);
    updateSearchParams([
      { name: "from", value: from },
      { name: "days", value: String(days) },
      { name: "to", value: "" },
      { name: "date", value: "" },
    ]);
    onClose();
  };

  const handleCustomDateChange = (item) => {
    setState([item.selection]);
  };

  const handleShowCustomComponent = () => {
    setShowCustomComponent(true);
  };

  const renderStaticRangeLabel = (range) => {
    if (range.label === "Custom") {
      return (
        <span
          className={`${
            showCustomComponent
              ? "rdrStaticRangeSelected custom-active-color"
              : ""
          }`}
          onClick={handleShowCustomComponent}>
          {range.label}
        </span>
      );
    }
    return range.label;
  };

  const handleChange = (item) => {
    const { startDate, endDate } = item.selection;
    if (
      startDate.getTime() !== endDate.getTime() &&
      startDate.toISOString() !== endDate.toISOString()
    ) {
      setState([item.selection]);
      dispatch(setDateRange(item.selection));
      const { from, days } = getWorklogDateRangeSearchParams(item.selection);
      updateSearchParams([
        { name: "from", value: from },
        { name: "days", value: String(days) },
        { name: "to", value: "" },
        { name: "date", value: "" },
      ]);
      setShowCustomComponent(false);
      onClose();
    } else {
      setState([item.selection]);
      setShowCustomComponent(true);

      window.dispatchEvent(new Event("resize"));
    }
  };

  return (
    <div className="d-grid">
      <div
        className={`d-flex worklog-date-filter ${
          isMobile ? "reverse-filter-section" : ""
        }`}>
        <div>
          {((isMobile && !showCustomComponent) || !isMobile) && (
            <DefinedRange
              onChange={handleChange}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              ranges={state}
              direction="horizontal"
              staticRanges={[
                ...defaultStaticRanges.filter(
                  (defRange) => defRange.label !== "Last Week"
                ),
                ...customStaticRanges,
              ]}
              renderStaticRangeLabel={renderStaticRangeLabel}
            />
          )}

          {showCustomComponent && (
            <div
              className={`d-flex align-items-center ${isMobile ? "mt-2" : ""}`}>
              <CustomButton
                onClick={() => {
                  dispatch(setDateRange(null));
                  onClose();
                  removeSearchParams(["from", "days", "to", "date"]);
                }}
                  className="reset-date-picker reset-btn"
                >
                Reset
              </CustomButton>
              <CustomButton
                onClick={setData}
                className="submit-date-picker"
                  variant="contained"
                >
                Apply
              </CustomButton>
            </div>
          )}
        </div>

        {showCustomComponent && (
          <CustomDateRangePicker
            state={state}
            handleCustomDateChange={handleCustomDateChange}
          />
        )}
      </div>
      {/* )} */}
    </div>
  );
}

export default DateRange;
